import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const Intercom: any;

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private matSnackBar: MatSnackBar) {}

  public showMessage(message: string): void {
    this.matSnackBar.open(`${message}`, null, { duration: 2000 });
  }

  public showError(message: string, durationMs = 8000): void {
    this.matSnackBar.open(message, 'Dismiss', {
      panelClass: ['snackbar-error'],
      duration: durationMs,
    });
  }
}
